import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import { setWindowHeight } from 'Store/Ui/Ui.action';

import WelcomePage from './WelcomePage.component';
import { WELCOME_PAGE_CLASS } from './WelcomePage.config';

import './WelcomePage.style';
/** @namespace Bodypwa/Component/WelcomePage/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    device: state.ConfigReducer.device,
    isWelcomePageActive: state.ConfigReducer.welcome_page_active,
    backgroundMobileImage: state.ConfigReducer.welcome_background_image_mobile,
    backgroundDesktopImage: state.ConfigReducer.welcome_background_image_desktop
});

/** @namespace Bodypwa/Component/WelcomePage/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    setWindowHeight: (windowHeight) => dispatch(setWindowHeight(windowHeight))
});
/** @namespace Bodypwa/Component/WelcomePage/Container */
export class WelcomePageContainer extends PureComponent {
    static propTypes = {
        device: PropTypes.shape({
            isMobile: PropTypes.bool
        }).isRequired,
        isWelcomePageActive: PropTypes.bool.isRequired,
        backgroundMobileImage: PropTypes.string.isRequired,
        backgroundDesktopImage: PropTypes.string.isRequired,
        setWindowHeight: PropTypes.func.isRequired
    };

    componentDidMount() {
        const { setWindowHeight } = this.props;
        setWindowHeight(window.innerHeight);
    }

    containerProps() {
        const {
            device: {
                isMobile
            },
            isWelcomePageActive,
            backgroundMobileImage,
            backgroundDesktopImage
        } = this.props;

        return {
            isMobile,
            isWelcomePageActive,
            backgroundMobileImage,
            backgroundDesktopImage
        };
    }

    renderWelcomePage() {
        const { isWelcomePageActive } = this.props;
        if (isWelcomePageActive) {
            document.querySelector('html').classList.add(WELCOME_PAGE_CLASS);
            return (
                <WelcomePage
                  { ...this.containerProps() }
                />
            );
        }

        return null;
    }

    render() {
        return this.renderWelcomePage();
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(WelcomePageContainer);
